import Vue from 'vue'
import App from './App.vue'
import router from './router'



import VueAnalytics from 'vue-analytics'

const isProd = process.env.NODE_ENV === 'production'

Vue.config.productionTip = false
Vue.use(VueAnalytics,{
  id : 'UA-17134389-21',
    router
    // debug : {
    // enabled: !isProd,
    //     sendHitTask: isProd
    // }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
